<template>
  <footer class="flex-shrink-0 h-auto">
    <LazyFooterCategories />
    <LazyFooterSecond />
    <LazyFooterLast />
  </footer>
</template>
